module.exports = __webpack_public_path__ + "7dfcb2fe37606b6aff3484471380e2c2.svg";